import React from 'react';
import { Button } from './button';

/**
 * TablePager — the standard surelia table pager (same shape as the Contratos /
 * Fianzas pages): "Mostrando X - Y de Z" plus Anterior / numbered pages /
 * Siguiente. Renders nothing when everything fits on one page.
 */
export function TablePager({ total, page, onPage, perPage, itemLabel = 'registros', compact = false }) {
  const totalPages = Math.max(1, Math.ceil(total / perPage));
  if (total <= perPage) return null;

  const startIndex = (page - 1) * perPage;
  const endIndex = Math.min(startIndex + perPage, total);

  const pageNumbers = [];
  const maxVisiblePages = 5;
  if (totalPages <= maxVisiblePages) {
    for (let i = 1; i <= totalPages; i++) pageNumbers.push(i);
  } else {
    pageNumbers.push(1);
    if (page <= 2) {
      for (let i = 2; i <= Math.min(3, totalPages - 1); i++) pageNumbers.push(i);
      if (totalPages > 3) pageNumbers.push('...');
    } else if (page >= totalPages - 1) {
      if (totalPages > 3) pageNumbers.push('...');
      for (let i = Math.max(totalPages - 2, 2); i <= totalPages - 1; i++) pageNumbers.push(i);
    } else {
      pageNumbers.push('...');
      pageNumbers.push(page);
      pageNumbers.push('...');
    }
    if (totalPages > 1) pageNumbers.push(totalPages);
  }

  const btnClass = compact ? 'text-xs px-2 py-1' : 'text-sm px-3 py-2';

  return (
    <div className={`flex flex-col sm:flex-row items-center justify-between gap-2 ${compact ? 'py-2' : 'py-3'}`}>
      <div className={`${compact ? 'text-xs' : 'text-sm'} text-zinc-600`}>
        Mostrando {startIndex + 1} - {endIndex} de {total} {itemLabel}
      </div>
      <div className="flex items-center justify-center gap-1.5 flex-wrap">
        <Button
          onClick={() => onPage(page - 1)}
          disabled={page === 1}
          outline
          color="surelia"
          className={btnClass}
        >
          Anterior
        </Button>
        <div className="flex items-center gap-1">
          {pageNumbers.map((p, idx) => (
            p === '...' ? (
              <span key={`ellipsis-${idx}`} className="px-1.5 text-zinc-400">...</span>
            ) : (
              <Button
                key={p}
                onClick={() => onPage(p)}
                color={page === p ? 'surelia' : 'white'}
                className={`${btnClass} ${compact ? 'min-w-[30px]' : 'min-w-[40px]'}`}
              >
                {p}
              </Button>
            )
          ))}
        </div>
        <Button
          onClick={() => onPage(page + 1)}
          disabled={page === totalPages}
          outline
          color="surelia"
          className={btnClass}
        >
          Siguiente
        </Button>
      </div>
    </div>
  );
}

export default TablePager;
